import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../theme';

/**
 * Custom hook that defines the styles for the explore page component.
 */
const useExplorePageStyles = makeStyles()(() => ({
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  componentsContainer: {
    display: 'flex',
    flex: '1 0 0',
    justifyContent: 'space-evenly',
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 0',
    maxWidth: '47%',
    minWidth: '47%',
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 0',
    maxWidth: '47%',
    minWidth: '47%',
  },
  titleContainer: {
    display: 'flex',
    flex: '1',
    width: '100%',
    minHeight: '40px',
    maxHeight: '40px',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.white,
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize.h6,
    backgroundColor: theme.background.darker,
  },
  horizontalPad: {
    height: '20px',
  },
  verticalPad: {
    width: '20px',
  },
}));

export default useExplorePageStyles;
